export default __webpack_public_path__ + "static/media/Canadiens.e1d4fe24.png";